"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconInvestorsHomepage = function IconInvestorsHomepage(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m29.709 4.749 16.186 16.186-10.529 10.528-16.185-16.185zm13.356 16.185-1.826-1.826a3.79 3.79 0 0 0-.047 3.7zm-2.604 2.604a4.79 4.79 0 0 1 .052-5.156L32.3 10.169a4.79 4.79 0 0 1-5.166-.017l-2.536 2.537a4.79 4.79 0 0 1-.014 5.163l8.176 8.176a4.79 4.79 0 0 1 5.192.02zM29.71 7.578l1.862 1.862a3.79 3.79 0 0 1-3.709-.015zm-7.7 7.699 1.86-1.86a3.79 3.79 0 0 1-.012 3.708zm13.357 13.357-1.878-1.878a3.79 3.79 0 0 1 3.737.019zm-4.21-12.507c-1.286 1.285-1.563 3.161-.517 4.207s2.922.77 4.207-.516c1.286-1.286 1.563-3.162.517-4.208-1.046-1.045-2.922-.769-4.208.517m.706.707c.933-.933 2.191-1.119 2.794-.517.602.603.416 1.86-.517 2.794-.932.932-2.19 1.118-2.793.516-.602-.602-.416-1.86.516-2.793M17 16.97v-2H4v21h11.063l-1.664 5H10v2h19v-2h-3.49l-1.672-5H34v-3h-2v1H6v-17zm.153 19h4.599l-.02.007L23.4 40.97h-7.894l1.663-4.994zm-4.267-15.743.708.706-3.48 3.49-.708-.706zm3.038 1.297-.707-.707-5.22 5.22.707.707zm.59 2.33-.707-.707-3.48 3.48.707.707z",
    clipRule: "evenodd"
  })));
};

export { IconInvestorsHomepage, IconInvestorsHomepage as default };
